import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IClientActivitiesState } from './client-activities';

const clientActivitiesStateSelector = createFeatureSelector<IClientActivitiesState>('clientActivities');

export const selectResponseVerifyDelivery = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseVerifyDelivery
);

export const selectResponseVerifyDeliveryNoPin = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseVerifyDeliveryNoPin
);

export const selectResponseRifiutaPacco = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseRifiutaPacco
);

export const selectResponseConsegnaPacco = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseConsegnaPacco
);

export const selectResponsePaccoSmarrito = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responsePaccoSmarrito
);
export const selectResponseVerifySale = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseVerifySale);

  export const selectResponseConfirmClientAcceptance = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseConfirmClientAcceptance
);

export const selectResponseConfirmClientAcceptanceDatamatrix = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseConfirmClientAcceptanceDatamatrix
);

export const selectResponseVerificaAccettazioneStampaPaperless = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseVerificaAccettazioneStampaPaperless
);

export const selectResponseEtichettaBXLWebApp = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseEtichettaWebApp
);

export const selectResponseEtichettaBXLLottomatica = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseEtichettaLottomatica
);

export const selectResponseCodiceBustaBXL = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseConfirmCodiceBusta
);

export const selectResponseParcelSale = createSelector(
  clientActivitiesStateSelector,
  (state: IClientActivitiesState) => state.responseParcelSale);
